import Backbone from "backbone";
import CountdownModel from "../models/CountdownModel";
import CountdownTemplate from "./Countdown.mustache"
import CountdownBigTemplate from "./CountdownBig.mustache"

 export default class extends Backbone.View{
   constructor(options) {
     super(options);
   }

   initialize(options) {
      this.countdownType = this.$el.hasClass('js-bf-countdown--big') ? 'big' : '';
      this.model = new CountdownModel(this.$el.data());
      this.start();
    }

    render() {
      const template = this.countdownType === 'big' ? CountdownBigTemplate : CountdownTemplate;
      this.$el.html(template.render(this.model.update().toJSON()));
    }

    start() {
        this.interval = setInterval(() => {
            this.render();

            if (this.model.getTime() <= 0) this.stop();
        }, 1000);
        this.render();

        return this;
    }

    stop() {
        clearInterval(this.interval);
    }
  }
